<script setup>
useCustomMeta('top', '')
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb()
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <LivecamMap />
      </div>
      <template #main-bottom>
        <LivecamAreaList />
        <LivecamFeature target-key="focus_livecam" />
        <!-- <NuxtLink
          to="https://weathernews.jp/ski/camera/?fm=livecam"
          external
        >
          <figure class="livecam-gerende" />
        </NuxtLink> -->
        <NuxtLink
          to="https://weathernews.jp/onebox/typhoon/?fm=livecam"
          external
        >
          <figure class="livecam-typhoon" />
        </NuxtLink>
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.livecam-gerende {
  width: 100%;
  aspect-ratio: 71 / 18;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('https://gvs.weathernews.jp/onebox/img/livecam/gerende_sp.webp')
}
.livecam-typhoon {
  width: 100%;
  aspect-ratio: 71 / 18;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('https://gvs.weathernews.jp/onebox/img/livecam/typhoon_sp.webp')
}
@media screen and (min-width: 830px) {
  .livecam-gerende {
    aspect-ratio: 151 / 18;
    background-image: url('https://gvs.weathernews.jp/onebox/img/livecam/gerende_pc.webp')
  }
  .livecam-typhoon {
    aspect-ratio: 151 / 18;
    background-image: url('https://gvs.weathernews.jp/onebox/img/livecam/typhoon_pc.webp')
  }
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
